import * as stylex from '@stylexjs/stylex'

import { formatMoney } from '../lib/ledger'

const styles = stylex.create({
  wrap: { display: 'flex', flexDirection: 'column', rowGap: '8px' },
  track: { display: 'flex', height: '10px', width: '100%', overflow: 'hidden', borderRadius: '9999px', backgroundColor: '#e7ece5' },
  confirmed: { height: '100%', backgroundColor: '#4d9360' },
  pending: { height: '100%', backgroundColor: '#d5a63f' },
  legend: { display: 'flex', flexWrap: 'wrap', gap: '8px 14px', fontSize: '11px', color: '#6f7d72' },
  item: { display: 'inline-flex', alignItems: 'center', gap: '6px' },
  dot: { height: '8px', width: '8px', borderRadius: '9999px' },
  green: { backgroundColor: '#4d9360' },
  yellow: { backgroundColor: '#d5a63f' },
  gray: { backgroundColor: '#cfd8cd' },
})

type Props = {
  confirmedAmountCents: number
  currency: string
  originalAmountCents: number
  pendingAmountCents: number
  remainingAmountCents: number
}

export default function PaymentProgress({
  confirmedAmountCents,
  currency,
  originalAmountCents,
  pendingAmountCents,
  remainingAmountCents,
}: Props) {
  const total = Math.max(1, originalAmountCents)
  const confirmedPercent = Math.min(100, Math.max(0, confirmedAmountCents / total * 100))
  const pendingPercent = Math.min(100 - confirmedPercent, Math.max(0, pendingAmountCents / total * 100))

  return <div {...stylex.props(styles.wrap)}>
    <div aria-label={`${formatMoney(confirmedAmountCents, currency)} confirmed, ${formatMoney(pendingAmountCents, currency)} pending, ${formatMoney(remainingAmountCents, currency)} remaining`} {...stylex.props(styles.track)} role="img">
      <span {...stylex.props(styles.confirmed)} style={{ width: `${confirmedPercent}%` }} />
      <span {...stylex.props(styles.pending)} style={{ width: `${pendingPercent}%` }} />
    </div>
    <div {...stylex.props(styles.legend)}>
      <span {...stylex.props(styles.item)}><span {...stylex.props(styles.dot, styles.green)} />{formatMoney(confirmedAmountCents, currency)} confirmed</span>
      {pendingAmountCents > 0 && <span {...stylex.props(styles.item)}><span {...stylex.props(styles.dot, styles.yellow)} />{formatMoney(pendingAmountCents, currency)} pending</span>}
      <span {...stylex.props(styles.item)}><span {...stylex.props(styles.dot, styles.gray)} />{formatMoney(remainingAmountCents, currency)} remaining</span>
    </div>
  </div>
}
